import { Reveal } from "../Reveal";

export const WhyWalk = () => (
  <section className="mx-auto max-w-6xl px-5 md:px-8 py-16 md:py-24" data-testid="why-walk-section">
    <div className="max-w-2xl">
      <Reveal className="mb-8">
        <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-ink">
          Why walk?
        </h2>
      </Reveal>
      <div className="space-y-5 text-base md:text-lg leading-relaxed text-ink/70">
        <Reveal>
          <p className="font-serif text-xl md:text-2xl text-ink">
            Put your headphones in. Get outside. Talk.
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <p>
            There’s something easier about talking when you’re moving. No
            room. No desk. No one staring back at you waiting for the right
            answer.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <p>
            Walk the dog. Push the pram. Walk around the block. Sit on a
            bench. I may well be walking too.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <p className="text-ink font-medium">
            The walk isn’t the point. The conversation is.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="text-sm text-ink/50">
            Walking is encouraged, never compulsory.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
